import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-form2b',
    templateUrl: './form2b.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Form2BComponent {

  constructor( private transactionInfoService: TransactionInfoService) {
      this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_EC_FORM2B]);
  }
  
}


